module.exports = __webpack_public_path__ + "assets/img/8_1762.6a9a3a01.jpg";